import React, { useEffect, useState } from 'react';
import Alert from '../../utils/Alert.js';
import DataTable from '../../components/Table/DataTable.jsx';
import { Link, Outlet } from 'react-router-dom';
import { getAllDiscountsService } from '../../services/discountsServices.js';
import DiscountAmount from './additionFields/DiscountAmount.jsx';
import Actions from './additionFields/Actions.jsx';
import { convertDateToJalaali } from '../../utils/convertDate.js';
import IsActive from './additionFields/IsActive.jsx';

const Discounts = () => {
    const [discounts, setDiscounts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const discountsCols = [
        {
            field: "title",
            text: "عنوان تخفیف"
        },
        {
            field: "code",
            text: "کد تخفیف"
        },
        {
            field: null,
            text: "مقدار تخفیف",
            element: (rowData) => <DiscountAmount rowData={rowData} />
        },
        {
            field: null,
            text: "تاریخ شروع",
            element: (rowData) => <span>{convertDateToJalaali(rowData.start_date)}</span>
        },
        {
            field: null,
            text: "تاریخ پایان",
            element: (rowData) => <span>{convertDateToJalaali(rowData.end_date)}</span>
        },
        {
            field: null,
            text: "وضعیت",
            element: (rowData) => <IsActive rowData={rowData} />
        },
        {
            field: null,
            text: "عملیات‌ها",
            element: (rowData) => <Actions rowData={rowData} />
        }
    ];

    const handleGetAllDiscounts = async () => {
        try {
            setIsLoading(true);
            const response = await getAllDiscountsService();
            if (response.status === 200) {
                setDiscounts(response.data);
            }
        } catch (error) {
          
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        handleGetAllDiscounts();
    }, []);

    return (
        <DataTable
            tableCols={discountsCols}
            tableData={discounts}
            itemsCount={10}
            title="تخفیف‌ها"
            searchField="title"
            searchTitle="عنوان تخفیف"
            isLoading={isLoading}
        >
            <Link to="/discounts/add-discount" 
            className="bg-primary px-3 py-1 rounded-lg 
            text-white">
                افزودن تخفیف
            </Link>
            <Outlet context={{
                setDiscounts
            }} />
        </DataTable>
    );
}

export default Discounts;
